import { FC, useCallback } from 'react';
import { useBooking, useDialog } from '@/logic/state';

import { DetailedSeatModel } from '@/logic/services';
import shallow from 'zustand/shallow';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';

export const CompanionConfirmDialog: FC = () => {
  const [dialog, setDialog] = useDialog(s => [s.dialog, s.setDialog], shallow);
  const [booking, setBooking] = useBooking(s => [s.booking, s.setBooking], shallow);

  const handleOkayClick = useCallback(
    (seat: DetailedSeatModel) => {
      const newSelectedTickets = booking.selectedTickets?.map((selectedTicket, index) => {
        if (index === dialog?.companionConfirmDialogPayload?.areaIndex) {
          return {
            ...selectedTicket,
            seats: [...selectedTicket.seats, { ...seat }],
          };
        } else {
          return selectedTicket;
        }
      });

      setDialog({});
      setBooking(prevState => ({
        ...prevState,
        selectedTickets: newSelectedTickets,
      }));
    },
    [booking, dialog?.companionConfirmDialogPayload?.areaIndex, setBooking, setDialog]
  );

  return (
    <ConfirmDialog
      buttonId='companion-confirm-dialog'
      img='/icons/booking/companion-icon.svg'
      widthImage='120px'
      heightImage='130px'
      altImage='alt.companion_icon'
      title='booking.companion'
      description='booking.companion_confirm_dialog.description'
      handleOkayClick={() => handleOkayClick(dialog?.companionConfirmDialogPayload?.seat)}
      handleCloseClick={() => setDialog({})}
    />
  );
};
